module.exports = __webpack_public_path__ + "img/w-xiuwei-nv.2b80ecf4.jpg";